module.exports = __webpack_public_path__ + "static/media/btn_google_play.3129fe51.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/EBook/imgs/btn_google_play.png
// module id = 1639
// module chunks = 0